<template>
  <!--
    <nav>
      <ul>
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/about">About</router-link>
        </li>
      </ul>
    </nav>
    <div>
      <h2>Vue v{{ vueVer }} with vue-router v4</h2>
      <router-view
        :address="address"
        :balance="balance"
        @connectWallet="connectWallet"
      ></router-view>
    </div>
  -->

<div id="app">
  <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
  <!-- <div v-if="showSidebar" class="relative z-50 xl:hidden" role="dialog" aria-modal="true">

    <div class="fixed inset-0 bg-gray-900/80"></div>

    <div class="fixed inset-0 flex">

      <div class="relative mr-16 flex w-full max-w-xs flex-1">

        <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
          <button @click="showSidebar = false" type="button" class="-m-2.5 p-2.5">
            <span class="sr-only">Close sidebar</span>
            <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 ring-1 ring-white/10">
          <div class="flex h-16 shrink-0 items-center">
            <img class="h-8 w-auto" src="logo.png" alt="FriendSniper">
          </div>
          <nav class="flex flex-1 flex-col">
            <ul role="list" class="flex flex-1 flex-col gap-y-7">
              <li>
                <ul role="list" class="-mx-2 space-y-1">
                  <li>
                    <a href="#" class="bg-gray-800 text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold">
                      <svg class="h-6 w-6 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z" />
                      </svg>
                      Dashboard
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <div class="text-xs font-semibold leading-6 text-gray-400">Coming soon</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                </ul>
              </li>
              <li class="-mx-6 mt-auto">
                <a href="#" class="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-white hover:bg-gray-800">
                  <img class="h-8 w-8 rounded-full bg-gray-800" src="https://upload.wikimedia.org/wikipedia/commons/5/59/User-avatar.svg" alt="">
                  <span class="sr-only">Your profile</span>
                  <span aria-hidden="true">Log in</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Static sidebar for desktop -->
  <div class="block md:fixed md:inset-y-0 md:z-2 md:flex md:w-72 md:flex-col">
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-black/10 px-6 ring-1 ring-white/5">
      <div class="flex h-16 shrink-0 items-center">
        <img class="w-auto" style="height: 1.65rem; margin-top: 2px; margin-right: 8px;" src="logo.png" alt="FriendSniper"> <i id="logo" class=" text-white font-bold" style="font-size: 18px;">FriendSniper</i>
      </div>
      <nav class="flex flex-1 flex-col">
        <ul role="list" class="flex flex-1 flex-col gap-y-7">
          <!-- <li>
            <ul role="list" class="-mx-2 space-y-1">
              <li>
                <a href="#" class="bg-gray-800 text-white group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold">
                  <svg class="h-6 w-6 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 17.25v-.228a4.5 4.5 0 00-.12-1.03l-2.268-9.64a3.375 3.375 0 00-3.285-2.602H7.923a3.375 3.375 0 00-3.285 2.602l-2.268 9.64a4.5 4.5 0 00-.12 1.03v.228m19.5 0a3 3 0 01-3 3H5.25a3 3 0 01-3-3m19.5 0a3 3 0 00-3-3H5.25a3 3 0 00-3 3m16.5 0h.008v.008h-.008v-.008zm-3 0h.008v.008h-.008v-.008z" />
                  </svg>
                  Dashboard
                </a>
              </li>
              <li>
                <a href="#" class="text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold">
                  <svg class="h-6 w-6 shrink-0" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Settings
                </a>
              </li>
            </ul>
          </li> -->
          <li class="mr-1">
            <div class="-ml-2 text-base font-semibold leading-6 text-white">Buy Keys</div>
            <ul role="list" class="-mx-2 mt-4 pl-0 pr-1">
              <!-- <li>
                <a href="#" class="text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold">
                  <span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800 text-[0.625rem] font-medium text-gray-400 group-hover:text-white">P</span>
                  <span class="truncate">Blah Blah</span>
                </a>
              </li>  -->
              <li class="ml-0 mb-4 w-full">
                <label for="email" class="block text-sm font-medium leading-6 text-white">Private Key</label>
                <div class="relative mt-2 rounded-md shadow-sm">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <i class="fa fa-lock"></i>
                  </div>
                  <input v-model="enteredPrivateKey" @change="fetchBalance" type="password" name="pk" id="pk" class="bg-gray-800 block w-full rounded-md border-0 py-1.5 pl-10 text-gray-100 ring-1 ring-inset ring-gray-700 placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="*************">
                </div>
              </li>
              <li class="ml-0 mb-4 w-full">
                <label for="email" class="block text-sm font-medium leading-6 text-white">Account to buy</label>
                <div class="relative mt-2 rounded-md shadow-sm">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <i class="fa fa-user"></i>
                  </div>
                  <input @change="fetchPrice()" v-model="enteredAddress" type="text" name="pk2" id="pk2" class="bg-gray-800 block w-full rounded-md border-0 py-1.5 pl-10 text-gray-100 ring-1 ring-inset ring-gray-700 placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-xs sm:leading-6" :placeholder="snipeMode ? 'Enter twitter @username' : 'Enter user\'s address (0x000...)'">
                </div>
              </li>

              <div class="mb-4 flex items-center justify-between">
                <span class="flex flex-grow flex-col">
                  <span class="mt-2 mb-1 text-sm font-medium leading-6 text-gray-300" id="availability-label">Snipe Mode&nbsp;
                    <span class="inline-flex items-center rounded-md bg-green-500/10 px-2 py-1 text-xs font-medium text-green-400 ring-1 ring-inset ring-green-500/20">Experimental</span>
                  </span>
                  <span class="text-xs text-gray-500" id="availability-description">Auto-buy @username shares when they join. Must keep this tab open.</span>
                </span>
                <button @click="toggleSnipeMode" type="button" :class="{ 'bg-indigo-600': snipeMode, 'bg-gray-800': !snipeMode }" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none" role="switch" aria-checked="false" aria-labelledby="availability-label" aria-describedby="availability-description">
                  <span aria-hidden="true" :class="{ 'translate-x-5 bg-indigo-400': snipeMode, 'translate-x-0': !snipeMode }" class=" pointer-events-none inline-block h-5 w-5 transform rounded-full bg-gray-600 shadow ring-0 transition duration-200 ease-in-out"></span>
                </button>
              </div>

              <li class="ml-0 mb-4 w-full">
                <label for="email" class="block text-sm font-medium leading-6 text-white">Number of keys to {{ snipeMode ? "snipe" : "buy" }}</label>
               
                <div class="mt-2 flex items-center justify-between">
                  <button @click="shareCount--" type="button" class="rounded-full bg-indigo-600 p-1.5 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor"><path d="M0 10h24v4h-24z"/></svg>
                  </button>
                  <div class="text-white text-lg">{{ shareCount }}</div>
                  <button @click="shareCount++" type="button" class="rounded-full bg-indigo-600 p-1.5 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                    </svg>
                  </button>
                </div>
              </li>

              <li class="ml-0 mb-3 w-full">
                <button :disabled="loading" @click="buyOrSnipe(enteredAddress)" type="button" :class="{ 'opacity-50': loading }" class="w-full block rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">
                  <span v-if="loading">Submitting...</span>
                  <span v-else>
                    {{ snipeMode ? "Snipe" : "Buy" }}
                    <span v-if="!snipeMode && lastPrice">({{  convertETH(lastPrice) * shareCount }} ETH)</span>
                  </span>

                </button>
<!-- 
                <div class="mt-2 relative flex items-start">
                  <div class="flex h-6 items-center ">
                    <input v-model="confirmPrice" id="comments" aria-describedby="comments-description" name="comments" type="checkbox" class="bg-gray-600 h-4 w-4 rounded border-gray-600 text-indigo-600">
                  </div>
                  <div class="ml-3 text-sm leading-6">
                    <label for="comments" class="font-medium text-gray-400">Confirm price</label>&nbsp;
                    <span id="comments-description" class="text-gray-500">before order.</span>
                  </div>
                </div> -->
              </li>

              <li v-if="snipes && snipes.length > 0" class="ml-0 mt-2 mb-3 w-full">
                <div class="mb-2 text-sm font-semibold leading-6 text-gray-400">Your Snipes:</div>
                <ul class="list-bullet">
                  <li class="mb-1 ml-0 text-sm block text-gray-300" v-for="snipe in snipes">
                    <span v-if="snipe.transactionHash" title="Completed">✅ </span>
                    <span v-else-if="!snipe.paused" title="Pending">⏳ </span>
                    <span v-else-if="snipe.paused" title="Paused">⏸ </span>
                    <span class="truncate text-white">
                      <a :href="'https://twitter.com/' + snipe.username" target="_blank">
                      @{{  snipe.username }}
                      </a>
                     </span>
                    • <span class="text-gray-400">{{  snipe.shareCount }} key{{Number(snipe.shareCount) > 1 ? 's' : ''}} </span>
                    • 
                    <a :href="'https://basescan.org/tx/' + snipe.transactionHash" target="_blank" v-if="snipe.transactionHash" class="ml-1 mr-2">
                      <img src="basescan.ico" class="h-3 inline-block -mt-1 opacity-100 " />
                    </a>
                    <i @click="deleteSnipe(snipe.username)" class="fa fa-trash text-gray-600 hover:text-gray-400 text-sm cursor-pointer"></i>
                  </li>
                </ul>
              </li>

            </ul>
          </li>
          <li class=" -mx-6 mt-auto">
            <a href="https://twitter.com/friendsniper_io" target="_blank" class="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-white hover:bg-gray-800">
              <img class="h-8 w-8 rounded-full object-contain bg-gray-800" src="https://upload.wikimedia.org/wikipedia/commons/6/6f/Logo_of_Twitter.svg" alt="">
              <span aria-hidden="true" class="text-xs">Official twitter 🚨</span>
              <span class="text-x text-gray-500">v0.2.1 <span class="text-gray-700">BETA</span></span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="md:pl-72">
    <!-- Sticky search header -->
    <div class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-6 border-b border-white/5 bg-gray-900 px-4 shadow-sm sm:px-6 lg:px-8">
      <!-- <button @click="showSidebar = true" type="button" class="-m-2.5 p-2.5 text-white xl:hidden">
        <span class="sr-only">Open sidebar</span>
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm0 5.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z" clip-rule="evenodd" />
        </svg>
      </button> -->

      <div class="block w-full float-right">
        <!-- <form class="flex flex-1" action="#" method="GET">
          <label for="search-field" class="sr-only">Search</label>
          <div class="relative w-full">
            <svg class="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clip-rule="evenodd" />
            </svg>
            <input id="search-field" class="block h-full w-full border-0 bg-transparent py-0 pl-8 pr-0 text-white focus:ring-0 sm:text-sm" placeholder="Search..." type="search" name="search">
          </div>
        </form> -->
        <div v-if="address" class="flex flex-1 text-gray-400 float-right text-base">
          <i class="fa fa-user text-sm"></i>&nbsp; {{ formatAddress(address) }} (<b class="text-white">{{ balance }} ETH</b>)
        </div>
      </div>
    </div>

    <main class="lg:pr-96">
      <header class="flex items-center justify-between border-b border-white/5 px-4 py-4 sm:px-6 sm:py-6 lg:px-8">
        <h1 class="text-base font-semibold leading-7 text-white">New Users</h1>

        <!-- Sort dropdown -->
        <div class="relative">
          <button @click="showSort = !showSort" type="button" class="flex items-center gap-x-1 text-sm font-medium leading-6 text-gray-200 hover:text-gray-500" id="sort-menu-button" aria-expanded="false" aria-haspopup="true">
            Sort by: {{  sortBy === 'new' ? 'Newest' : 'Lowest Price' }}
            <svg class="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z" clip-rule="evenodd" />
            </svg>
          </button>

          <div v-if="showSort" class="absolute right-0 z-10 mt-2.5 w-40 origin-top-right rounded-md text-gray-200 bg-gray-800 py-2 shadow-lg focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="sort-menu-button" tabindex="-1">
            <a @click="setSort('new')" class="cursor-pointer block px-3 py-1 text-sm leading-6 hover:text-white hover:bg-gray-700" :class="{ 'bg-gray-700': sortBy === 'new'}" role="menuitem" tabindex="-1" id="sort-menu-item-0">Newest</a>
            <a @click="setSort('price')" class="cursor-pointer block px-3 py-1 text-sm leading-6 hover:text-white hover:bg-gray-700" :class="{ 'bg-gray-700': sortBy === 'price'}" role="menuitem" tabindex="-1" id="sort-menu-item-1">Lowest Price</a>
          </div>
        </div>
      </header>

      <!-- Deployment list -->
      <ul v-if="!newUsers || newUsers.length === 0" type="button" class="mx-auto block w-full rounded-lg border-1 border-dashed border-gray-600 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        <i class="text-4xl fa fa-users"></i>
        <span class="mt-2 block text-xl font-semibold text-gray-700">New users will appear here as they join.</span>
      </ul>

      <ul v-else role="list" class="divide-y divide-white/5">
        <li v-for="user in newUsers.sort((a,b) => sortBy == 'new' ? b.createdAt - a.createdAt : Number(a.displayPrice) - Number(b.displayPrice))" class="hover:bg-gray-800 relative flex items-center space-x-4 px-4 py-4 sm:px-6 lg:px-8">
          <div class="flex items-center ">
              <div class="inline-block flex-none rounded-full p-1 text-gray-500 bg-gray-100/10">
                <!-- <div class="h-2 w-2 rounded-full bg-current"></div> -->
                <img :src="user.twitterPfpUrl" class="h-10 rounded-full" />
              </div>
            </div>
          <div class="min-w-0 flex-auto">
            <div class="flex items-center gap-x-3">
              <h2 class="min-w-0 text-sm font-semibold leading-6 text-white">
                <a :href="'https://twitter.com/' + user.twitterUsername" class="flex gap-x-2 items-center" target="_blank">
                  <span class="truncate text-base">{{ user.twitterName}}</span>
                  <!-- <span class="text-gray-400">/</span> -->
                  <span class="whitespace-nowrap text-gray-500">@{{ user.twitterUsername }}</span>
                  <span class="absolute inset-0"></span>
                </a>
              </h2>
            </div>
            <div class="mt-0 flex items-center gap-x-2.5 text-xs leading-5 text-gray-400">
              <p class="truncate flex items-center">
                <a :href="'https://basescan.org/address/' + user.address" target="_blank" style="z-index: 9" class="text-gray-400 hover:text-gray-300">
                  <img src="basescan.ico" class="h-3 inline-block -mt-1 mr-2 opacity-50 " /> {{  formatAddress(user.address) }}
                </a>
              </p>
              <svg viewBox="0 0 2 2" class="h-0.5 w-0.5 flex-none fill-gray-300">
                <circle cx="1" cy="1" r="1" />
              </svg>
              <p class="whitespace-nowrap text-gray-600">Joined {{ moment(user.createdAt).fromNow() }}</p>
            </div>
          </div>

          <div v-if="user.displayPrice" class="text-gray-100 text-sm" style="z-index: 9">
            {{ convertETH(user.displayPrice) }} ETH <i @click="refreshPrice(user.address)" class="ml-1 fa fa-refresh text-gray-700 hover:text-gray-400 text-sm cursor-pointer"></i>
          </div>

          <a @click="enteredAddress = user.address" style="z-index: 9" class="cursor-pointer">
            <div class="rounded-full flex-none py-1 px-2 text-xs font-medium ring-1 ring-inset text-white bg-sky-600 hover:bg-sky-400 ring-gray-400/20 px-5">Buy</div>
          </a>
          <a :href="'https://www.friend.tech/rooms/' + user.address" target="_blank" style="z-index: 9" class="text-gray-700 hover:text-gray-300">
            <i class="fa-solid fa-up-right-from-square"></i>
          </a>
          <!-- <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
          </svg> -->
        </li>

      </ul>
    </main>

    <!-- Activity feed -->
    <aside class="bg-black/10 lg:fixed lg:bottom-0 lg:right-0 lg:top-16 lg:w-96 lg:overflow-y-auto lg:border-l lg:border-white/5">
      <header class="flex items-center justify-between border-b border-white/5 px-4 py-4 sm:px-6 sm:py-6 lg:px-8">
        <h2 class="text-base font-semibold leading-7 text-white">Trade Activity</h2>
        <!-- <a href="#" class="text-sm font-semibold leading-6 text-indigo-400">View all</a> -->
      </header>
      <ul v-if="newTrades" role="list" class="divide-y divide-white/5">
        <li v-for="trade in newTrades.sort((a,b) => b.createdAt - a.createdAt)" class="hover:bg-gray-800 px-4 py-4 sm:px-6 lg:px-8 w-full">
          <a :href="'https://basescan.org/tx/' + trade.transactionHash" target="_blank">
            <div class="flex items-center w-full">
              <img :src="trade.trader.twitterPfpUrl" alt="" class="h-6 w-6 flex-none rounded-full bg-gray-800">
              <a class="flex-auto" :href="'https://basescan.org/address/' + trade.trader.username" target="_blank">
                <h3 class="truncate text-sm font-semibold leading-6 text-white">{{ formatAddress(trade.trader.name) }}</h3>
              </a>
              <time datetime="2023-01-23T11:00" class=" flex-none text-xs" :class="{ 'text-red-400': !trade.isBuy, 'text-green-400': trade.isBuy }">{{ convertETH(trade.ethAmount) }} ETH</time>
            </div>
            <div class="flex mt-3 items-center gap-x-3 w-full">
              <p class=" truncate text-sm text-gray-500">
                <span v-if="trade.isBuy" class="text-green-400">Bought </span>
                <span v-else class="text-red-400">Sold </span>
                <span class="text-gray-400">{{ trade.shareAmount }} key<span v-if="Number(trade.shareAmount > 1)">s</span></span> of <a :href="'https://www.friend.tech/rooms/' + trade.subject.address" target="_blank"><img :src="trade.subject.twitterPfpUrl" class="h-4 rounded-full inline-block" /> <span class="font-mono text-gray-400 truncate">{{ formatAddress(trade.subject.twitterName) }}</span></a>
              </p>
              <div class="ml-3 flex-none text-xs float-right text-gray-600">{{moment(trade.createdAt).fromNow()}}</div>
            </div>
          </a>
        </li>

      </ul>
    </aside>
  </div>


  <!-- SUCCESS MODAL -->
  <div v-if="showSuccessModal" class="relative z-90" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
          <div>
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-base font-semibold leading-6 text-gray-200" id="modal-title">Transaction submitted!</h3>
              <div class="mt-2">
                <p class="text-sm text-gray-400">The transaction may takes a few minutes to confirm.</p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <button @click="toggleSuccessModal" type="button" class="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2">Done</button>
            <a :href="'https://basescan.org/tx/' + lastTransactionHash" target="_blank">
              <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-inset ring-gray-700 hover:bg-gray-900 sm:col-start-1 sm:mt-0">View transaction</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- PRICE MODAL -->
    <div v-if="showPriceModal" class="relative z-90" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
          <div>
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3 class="text-base font-semibold leading-6 text-gray-200 mb-2" id="modal-title">Your price per share:</h3>
              <h3 class="text-2xl font-semibold leading-6 text-gray-200" id="modal-title">{{ lastPrice }} ETH</h3>
              <div class="mt-2">
                <p class="text-sm text-gray-400">Click "Confirm" to submit the transaction.</p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <button @click="confirmPrice" type="button" class="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2">Confirm</button>
            <button @click="togglePriceModal" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-inset ring-gray-700 hover:bg-gray-900 sm:col-start-1 sm:mt-0">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

</template>

<script>
import * as constants from "./constants.js";
let Web3 = window.Web3;

/* ---- WEB3MODAL: ---- */
const Web3Modal = window.Web3Modal.default;
const WalletConnectProvider = window.WalletConnectProvider.default;
const Fortmatic = window.Fortmatic;

let web3;
let web3Modal;

function init() {
  console.log("Initializing example");
  console.log("WalletConnectProvider is", WalletConnectProvider);
  console.log("Fortmatic is", Fortmatic);
  console.log(
    "window.web3 is",
    window.web3,
    "window.ethereum is",
    window.ethereum
  );

  // Tell Web3modal what providers we have available.
  // Built-in web browser provider (only one can exist as a time)
  // like MetaMask, Brave or Opera is added automatically by Web3modal
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: constants.infuraAPIKey,
      },
    },
    fortmatic: {
      package: Fortmatic,
      options: {
        key: constants.fortmaticAPIKey,
      },
    },
  };

  web3Modal = new Web3Modal({
    cacheProvider: false, // optional
    providerOptions, // required
    disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
    theme: "dark",
  });

  console.log("Web3Modal instance is", web3Modal);
}

/* ---- VUE APP: ---- */
export default {
  name: "App",
  components: {},
  data() {
    return {
      sortBy: 'new',
      showSort: false,
      loading: false,
      confirmPrice: true,
      showPriceModal: false,
      showSuccessModal: false,
      snipeMode: false,
      enteredAddress: null,
      enteredPrivateKey: null,
      shareCount: 1,
      moment: window.moment,
      address: null,
      balance: null,
      newUsers: [],
      newTrades: [],
      showSidebar: false,
      web3: null,
      web3s: null,
      lastTransactionHash: "",
      lastPrice: "",
      snipes: [],
      activityListener: null,
      lastBlockNumber: "latest"
    };
  },
  watch: {
    enteredAddress: {
      handler(old, newk) {
      if(old !== newk) {
        this.fetchPrice();
      }
      }
    },
    /*newUsers_OLD: {
        handler(newVal, oldVal) {
            const newUsersAdded = [];
            for (let user of newVal) {
                // If the user exists in the old value, stop the loop
                if (oldVal.some(oldUser => oldUser.subject.address === user.subject.address)) {
                    break;
                }
                newUsersAdded.push(user);
            }
            if (newUsersAdded.length > 0) {
              console.log('New users added:', newUsersAdded);
              // Fetch and parse the snipes array from localStorage
              if(this.enteredPrivateKey) {
                let snipes = JSON.parse(localStorage.getItem('snipes')) || [];
                if(snipes.length > 0) {
                  snipes = snipes.filter(s => !s.paused);
                }

                // For each new user, compare with snipes
                for (let user of newUsersAdded) {
                  // Find the snipe that matches the user's username
                  // Find the index of the snipe that matches the user's username
                  let snipeIndex = snipes.findIndex(snipe => snipe.username === user.subject.username);

                  if (snipeIndex !== -1) {
                    let matchedSnipe = snipes[snipeIndex]; //snipes.find(snipe => snipe.username === user.subject.username);
                    // Update the paused property of the matched snipe to true
                    snipes[snipeIndex].paused = true;
                    // Save the updated snipes array back to localStorage
                    localStorage.setItem('snipes', JSON.stringify(snipes));

                    this.updateSnipes();
                    // Call the desired function with both the user and the matched snipe
                    setTimeout(() => {
                        this.snipe(user.subject.address, user.subject.username, matchedSnipe.shareCount);
                    }, 100);
                  }
                }
              }
            }
        },
        deep: true
    },*/
    /*
    newUsers: {
        handler(newVal, oldVal) {
            const newUsersAdded = [];
            for (let user of newVal) {
                // If the user exists in the old value, stop the loop
                if (oldVal.some(oldUser => oldUser.address === user.address)) {
                    break;
                }
                newUsersAdded.push(user);
            }
            if (newUsersAdded.length > 0) {
              console.log('New users added:', newUsersAdded);
              // Fetch and parse the snipes array from localStorage
              if(this.enteredPrivateKey) {
                let snipes = JSON.parse(localStorage.getItem('snipes')) || [];
                if(snipes.length > 0) {
                  snipes = snipes.filter(s => !s.paused);
                }

                // For each new user, compare with snipes
                for (let user of newUsersAdded) {
                  // Find the snipe that matches the user's username
                  // Find the index of the snipe that matches the user's username
                  let snipeIndex = snipes.findIndex(snipe => snipe.username === user.twitterUsername);

                  if (snipeIndex !== -1) {
                    let matchedSnipe = snipes[snipeIndex]; //snipes.find(snipe => snipe.username === user.subject.username);
                    // Update the paused property of the matched snipe to true
                    snipes[snipeIndex].paused = true;
                    // Save the updated snipes array back to localStorage
                    localStorage.setItem('snipes', JSON.stringify(snipes));

                    this.updateSnipes();
                    // Call the desired function with both the user and the matched snipe
                    setTimeout(() => {
                        this.snipe(user.address, user.twitterUsername, matchedSnipe.shareCount);
                    }, 100);
                  }
                }
              }
            }
        },
        deep: true
    }
    */
  },
  computed: {
    userAddress: function () {
      return this.address;
    },
  },
  methods: {
    setSort(s) {
      this.sortBy = s;
      this.showSort = false
    },
    isEthereumAddress: function(address) {
      const ethAddressPattern = /^0x[a-fA-F0-9]{40}$/;
      return ethAddressPattern.test(address);
    },
    deleteSnipe: function(username) {
      // Fetch and parse the snipes array from localStorage
      let snipes = JSON.parse(localStorage.getItem('snipes')) || [];
      // Filter out the snipe with the specified username
      let updatedSnipes = snipes.filter(snipe => snipe.username !== username);
      // Save the updated snipes array back to localStorage
      this.snipes = updatedSnipes;
      this.$forceUpdate();
      localStorage.setItem('snipes', JSON.stringify(updatedSnipes));
    },
    togglePriceModal: function(amount) {
      if(this.showPriceModal) {
        this.lastPrice = null;
        this.showPriceModal = false;
      } else {
        this.lastPrice = this.convertETH(amount);
        this.showPriceModal = true;
      }
    },
    toggleSuccessModal: function(transactionHash) {
      if(this.showSuccessModal) {
        this.lastTransactionHash = "";
        this.showSuccessModal = false;
      } else {
        this.lastTransactionHash = transactionHash;
        this.showSuccessModal = true;
      }
    },
    toggleSnipeMode: function() {
      this.snipeMode = !this.snipeMode;
      this.enteredAddress = null;
      this.lastPrice = "";
    },
    formatAddress: function(addy) {
      return addy.substr(0,6) + "..." + addy.substr(-6);
    },
    fetchBalance: function() {
      if(this.enteredPrivateKey) { 
        const privateKey = this.enteredPrivateKey; // Be cautious with handling private keys. Never expose or hard-code them.
        const account = this.web3.eth.accounts.privateKeyToAccount('0x' + privateKey);
        this.web3.eth.accounts.wallet.add(account);
        this.web3.eth.defaultAccount = account.address;
        this.address = this.web3.eth.defaultAccount;
        console.log("Logged in as" , this.address);
        this.web3.eth.getBalance(this.address).then((balance) => {
          let convertedBalance = this.web3.utils.fromWei(balance, "ether");
          const humanFriendlyBalance = parseFloat(convertedBalance).toFixed(
            3
          );
          this.balance = humanFriendlyBalance;
          console.log("Balance = ", this.balance);
        });
      }
    },
    buyOrSnipe: function(addy) {
      if(!this.enteredPrivateKey) {
        alert("Please enter the private key of your Friend.tech wallet!");
        return;
      }

      if(this.snipeMode) this.addSnipe(addy, this.shareCount);
      else this.buy(addy);
    },
    addSnipe: function(newUsername, shareCount = 1) {
      newUsername = newUsername.replace("@", "");

      // Fetch and parse the snipes array from localStorage
      let snipes = JSON.parse(localStorage.getItem('snipes')) || [];

      // Check if the address already exists in snipes
      let addressExists = snipes.some(snipe => snipe.username === newUsername);

      // If the address doesn't exist, add a new object to snipes
      if (!addressExists) {
          snipes.push({ username: newUsername, shareCount: shareCount }); // TODO: Add Max price
          // Update this.snipes
          this.snipes = snipes;
          this.$forceUpdate();
          // Save the updated snipes array back to localStorage
          localStorage.setItem('snipes', JSON.stringify(snipes));
      }
    },
    snipe: function(addressToBuy, username, shareCount = 1) {
      const privateKey = this.enteredPrivateKey; // Be cautious with handling private keys. Never expose or hard-code them.
      if(privateKey) {
        const account = this.web3.eth.accounts.privateKeyToAccount('0x' + privateKey);
        this.web3.eth.accounts.wallet.add(account);
        this.web3.eth.defaultAccount = account.address;
        this.address = this.web3.eth.defaultAccount;
        console.log("Logged in as" , this.web3.eth.defaultAccount);
        
        const contractABI = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"trader","type":"address"},{"indexed":false,"internalType":"address","name":"subject","type":"address"},{"indexed":false,"internalType":"bool","name":"isBuy","type":"bool"},{"indexed":false,"internalType":"uint256","name":"shareAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"protocolEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"subjectEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"supply","type":"uint256"}],"name":"Trade","type":"event"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"buyShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeeDestination","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"sellShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_feeDestination","type":"address"}],"name":"setFeeDestination","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setProtocolFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setSubjectFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"sharesBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"sharesSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"subjectFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]; // Your contract ABI
        const contractAddress = "0xCF205808Ed36593aa40a44F10c7f7C2F67d4A4d4"; 
        const myContract = new this.web3.eth.Contract(contractABI, contractAddress);

        // GET PRICE
        this.web3.eth.getGasPrice().then(gasPrice => {
          myContract.methods.getBuyPriceAfterFee(addressToBuy, shareCount).call({ from: account.address }).then(result => {
                  let amount = result;
                  let buyNow = myContract.methods.buyShares(addressToBuy, shareCount);

                  // BUY SHARES
                  buyNow.estimateGas({ from: account.address, value: amount }).then(gasLimit => {
                    // 1. Prepare the transaction data
                    const txData = {
                        from: this.address,
                        to: myContract._address,
                        gas: gasLimit,
                        gasPrice: gasPrice,
                        value: amount,
                        data: buyNow.encodeABI()
                    };

                    // 2. Sign the Transaction
                    this.web3.eth.accounts.signTransaction(txData, privateKey).then(signedTx => {
                        // 3. Send the Signed Transaction
                        return this.web3.eth.sendSignedTransaction(signedTx.rawTransaction);
                    })
                      .then(result => {
                        console.log("Submitted!", 'https://basescan.org/tx/' + result.transactionHash, result);
                        // Update snipes
                        let snipes = JSON.parse(localStorage.getItem('snipes')) || [];
                        if(snipes.length > 0) {
                          //snipes = snipes.filter(s => !s.paused);
                          let snipeIndex = snipes.findIndex(snipe => snipe.username === username);
                          if(snipeIndex !== -1) {
                            snipes[snipeIndex].transactionHash = result.transactionHash;
                            snipes[snipeIndex].paused = true;
                            localStorage.setItem('snipes', JSON.stringify(snipes));
                            this.updateSnipes();
                          }
                        }
                      })
                      .catch(error => {
                          console.error(error);
                      });

                    })
                    .catch(error => {
                        console.error(error);
                    });
              })
              .catch(error => {
                  console.error(error);
              });
          });

        } else { 
          console.log("no pk"); 
        }
    },
    updateSnipes: function() {
      this.snipes = JSON.parse(localStorage.getItem('snipes')) || [];
    },
    fetchPrice: function() {
      if(this.enteredAddress && !this.snipeMode && this.isEthereumAddress(this.enteredAddress)) {
        const contractABI = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"trader","type":"address"},{"indexed":false,"internalType":"address","name":"subject","type":"address"},{"indexed":false,"internalType":"bool","name":"isBuy","type":"bool"},{"indexed":false,"internalType":"uint256","name":"shareAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"protocolEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"subjectEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"supply","type":"uint256"}],"name":"Trade","type":"event"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"buyShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeeDestination","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"sellShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_feeDestination","type":"address"}],"name":"setFeeDestination","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setProtocolFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setSubjectFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"sharesBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"sharesSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"subjectFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]; // Your contract ABI
        const contractAddress = "0xCF205808Ed36593aa40a44F10c7f7C2F67d4A4d4"; 
        const myContract = new this.web3.eth.Contract(contractABI, contractAddress);
        
        // GET PRICE
        myContract.methods.getBuyPriceAfterFee(this.enteredAddress, this.shareCount).call({ from: this.address })
            .then(result => {
                this.lastPrice = result;
                console.log(result);
            });
      }
    },
    buy: function(addressToBuy) {
      if(!this.enteredPrivateKey) {
        alert("Please enter the private key of your Friend.tech wallet!");
        return;
      }

      const privateKey = this.enteredPrivateKey; // Be cautious with handling private keys. Never expose or hard-code them.
      const account = this.web3.eth.accounts.privateKeyToAccount('0x' + privateKey);
      this.web3.eth.accounts.wallet.add(account);
      this.web3.eth.defaultAccount = account.address;
      this.address = this.web3.eth.defaultAccount;
      console.log("Logged in as" , this.web3.eth.defaultAccount);
      
      const contractABI = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"trader","type":"address"},{"indexed":false,"internalType":"address","name":"subject","type":"address"},{"indexed":false,"internalType":"bool","name":"isBuy","type":"bool"},{"indexed":false,"internalType":"uint256","name":"shareAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"protocolEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"subjectEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"supply","type":"uint256"}],"name":"Trade","type":"event"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"buyShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeeDestination","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"sellShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_feeDestination","type":"address"}],"name":"setFeeDestination","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setProtocolFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setSubjectFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"sharesBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"sharesSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"subjectFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]; // Your contract ABI
      const contractAddress = "0xCF205808Ed36593aa40a44F10c7f7C2F67d4A4d4"; 
      const myContract = new this.web3.eth.Contract(contractABI, contractAddress);

      // GET PRICE
      this.web3.eth.getGasPrice().then(gasPrice => {
        myContract.methods.getBuyPriceAfterFee(addressToBuy, this.shareCount).call({ from: this.address }).then(result => {
              let amount = result;

              this.lastPrice = result;
              let buyNow = myContract.methods.buyShares(addressToBuy, this.shareCount);
              // BUY SHARES
              buyNow.estimateGas({ from: this.address, value: amount }).then(gasLimit => {
                  this.loading = true;
                  // 1. Prepare the transaction data
                  const txData = {
                      from: this.address,
                      to: myContract._address, // Assuming buyNow is a contract instance
                      gas: gasLimit,
                      gasPrice: gasPrice,
                      value: amount,
                      data: buyNow.encodeABI() // Replace with your actual method name and parameters
                  };

                  // 2. Sign the Transaction
                  this.web3.eth.accounts.signTransaction(txData, privateKey) // Ensure you have access to the private key safely
                      .then(signedTx => {
                          // 3. Send the Signed Transaction
                          return this.web3.eth.sendSignedTransaction(signedTx.rawTransaction);
                      })
                      .then(result => {
                          this.loading = false;
                          console.log("Submitted!", 'https://basescan.org/tx/' + result.transactionHash);
                          // Open modal
                          this.toggleSuccessModal(result.transactionHash);
                      })
                      .catch(error => {
                          this.loading = false;
                          console.error(error);
                      });
                })
                .catch(error => {
                    this.loading = false;
                    console.error(error);
                });
            })
            .catch(error => {
                console.error(error);
            });

        });
    },
    convertETH: function(eth) {
      return Number(eth) / 1e18;
    },
    refreshPrice: function(address) {
        const contractABI = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"trader","type":"address"},{"indexed":false,"internalType":"address","name":"subject","type":"address"},{"indexed":false,"internalType":"bool","name":"isBuy","type":"bool"},{"indexed":false,"internalType":"uint256","name":"shareAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"protocolEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"subjectEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"supply","type":"uint256"}],"name":"Trade","type":"event"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"buyShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeeDestination","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"sellShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_feeDestination","type":"address"}],"name":"setFeeDestination","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setProtocolFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setSubjectFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"sharesBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"sharesSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"subjectFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]; // Your contract ABI
        const contractAddress = "0xCF205808Ed36593aa40a44F10c7f7C2F67d4A4d4"; 
        const myContract = new this.web3.eth.Contract(contractABI, contractAddress);
        
        // GET PRICE
        myContract.methods.getBuyPrice(address, "1").call()
          .then(result => {
            let userIndex = this.newUsers.findIndex(user => user.address === address);
            if (userIndex !== -1) {
              this.newUsers[userIndex].displayPrice = result;
              this.$forceUpdate();
            }
          });
    },
    fetchActivity: function() {
      //const privateKey = this.enteredPrivateKey; // Be cautious with handling private keys. Never expose or hard-code them.
      //const account = this.web3.eth.accounts.privateKeyToAccount('0x' + privateKey);
      //this.web3.eth.accounts.wallet.add(account);
     //this.web3.eth.defaultAccount = account.address;
     //this.address = this.web3.eth.defaultAccount;      
     //if(!this.activityListener) {
      const contractABI = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"trader","type":"address"},{"indexed":false,"internalType":"address","name":"subject","type":"address"},{"indexed":false,"internalType":"bool","name":"isBuy","type":"bool"},{"indexed":false,"internalType":"uint256","name":"shareAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"ethAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"protocolEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"subjectEthAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"supply","type":"uint256"}],"name":"Trade","type":"event"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"buyShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getBuyPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getSellPriceAfterFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeeDestination","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"protocolFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sharesSubject","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"sellShares","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_feeDestination","type":"address"}],"name":"setFeeDestination","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setProtocolFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_feePercent","type":"uint256"}],"name":"setSubjectFeePercent","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"sharesBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"sharesSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"subjectFeePercent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];
      const contractAddress = "0xCF205808Ed36593aa40a44F10c7f7C2F67d4A4d4"; 
      const myContract = new this.web3s.eth.Contract(contractABI, contractAddress);
        if(this.activityListener) {
          this.activityListener.removeAllListeners("data");
          this.activityListener.removeAllListeners("error");
          this.activityListener = null;
        }

        this.activityListener = myContract.events.Trade({
            fromBlock: this.lastBlockNumber
        });
        
        if(this.activityListener) {
          this.activityListener.on('data', (event) => {
            console.log("New trade! ", event);
            this.lastBlockNumber = event.blockNumber;
            let subject = event.returnValues.subject;
            let trader = event.returnValues.trader;
            // Check if new user
            if(subject === trader) {
              // Check if buy
              if(event.returnValues.isBuy) {
                // Fetch user details:
                fetch('https://prod-api.kosetto.com/users/' + subject, {method: "GET"})
                  .then(response => {
                    return response.json();
                  })
                  .then((data) => {
                    if(data && data.address && data.holdingCount && data.holdingCount <= 1 && data.holderCount && data.holderCount <= 5) { //(data.shareSupply /*|| Number(data.shareSupply) <= 9*/)) {
                      if(!this.newUsers) this.newUsers = [];
                      data.createdAt = new Date().getTime();
                      // Check if the address already exists in newUsers
                      const exists = this.newUsers.some(user => user.address === data.address);
                      if (!exists) {
                          this.newUsers.push(data);

                          // Snipe if necessary
                          if(this.enteredPrivateKey) {
                            let snipes = JSON.parse(localStorage.getItem('snipes')) || [];
                            if(snipes.length > 0) {
                              snipes = snipes.filter(s => !s.paused);
                            }

                            // Find the index of the snipe that matches the user's username
                            let snipeIndex = snipes.findIndex(snipe => snipe.username === data.twitterUsername);

                            if (snipeIndex !== -1) {
                              let matchedSnipe = snipes[snipeIndex]; //snipes.find(snipe => snipe.username === user.subject.username);
                              // Update the paused property of the matched snipe to true
                              snipes[snipeIndex].paused = true;
                              // Save the updated snipes array back to localStorage
                              localStorage.setItem('snipes', JSON.stringify(snipes));
                              this.updateSnipes();

                              // Call the desired function with both the user and the matched snipe
                              setTimeout(() => {
                                  this.snipe(data.address, data.twitterUsername, matchedSnipe.shareCount);
                              }, 100);
                            }
                          }
                          
                      }
                    }
                  });
              }
            } else {
              let data = event.returnValues;
              if(data) {
                if(!this.newTrades) this.newTrades = [];
                data.createdAt = new Date().getTime();
                data.transactionHash = event.transactionHash;
                data.trader = {};
                data.trader.twitterPfpUrl = "https://upload.wikimedia.org/wikipedia/commons/5/59/User-avatar.svg";
                data.trader.username = trader;
                data.trader.name = trader;
                data.trader.address = trader;
                data.subject = {};
                data.subject.twitterPfpUrl = "https://upload.wikimedia.org/wikipedia/commons/5/59/User-avatar.svg";
                data.subject.twitterName = subject;
                data.subject.address = subject;
                this.newTrades.push(data);
                // let tempTrades = this.newTrades;
                // tempTrades.push(data);
                // this.newTrades = tempTrades;
                // this.$forceUpdate();
              }
            }
          });
          this.activityListener.on('error', console.error);
        }
      //}
    },
    fetchActivityOld2: function() {
      fetch('https://friendmex.com/api/stats/newest', { mode: "cors", method: "GET"})
        .then(response => {
          // if (!response.ok) {
          //   throw new Error('Network response was not ok');
          // }
          return response.json();
        })
        .then(data => {
          if (data) {
            console.log(data);
            // Sort the events by createdAt in descending order
            data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
            let newUsersTemp = [];
            let newTradesTemp = [];
            // Split the events into newUsers and newTrades based on the criteria
            data.forEach(event => {
                //if (event.trader.address === event.subject.address) {
                    newUsersTemp.push(event);
                //} else {
                //    newTradesTemp.push(event);
                //}
            });

            // newUsersTemp = newUsersTemp.filter((user, index, selfArray) => {
            //     return index === selfArray.findIndex((u) => u.subject.address === user.subject.address);
            // });

            // Update only if there are changes
            if (JSON.stringify(newUsersTemp) !== JSON.stringify(this.newUsers)) {
                this.newUsers = newUsersTemp;
            }
            // if (JSON.stringify(newTradesTemp) !== JSON.stringify(this.newTrades)) {
            //     this.newTrades = newTradesTemp;
            // }
          }

          // Display or process the data as required. For now, we're just logging it.
          console.log("All New Users:", this.newUsers);
          //console.log("New Trades:", this.newTrades);
        })
        .catch(error => {
          console.log('There was a problem with the fetch operation:', error.message);
        });
    },
    fetchActivity_OLD: function() {
      fetch('https://prod-api.kosetto.com/global-activity')
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          if (data && data.events) {
            // Sort the events by createdAt in descending order
            data.events.sort((a, b) => b.createdAt - a.createdAt);
            let newUsersTemp = [];
            let newTradesTemp = [];
            // Split the events into newUsers and newTrades based on the criteria
            data.events.forEach(event => {
                if (event.trader.address === event.subject.address) {
                    newUsersTemp.push(event);
                } else {
                    newTradesTemp.push(event);
                }
            });

            newUsersTemp = newUsersTemp.filter((user, index, selfArray) => {
                return index === selfArray.findIndex((u) => u.subject.address === user.subject.address);
            });

            // Update only if there are changes
            if (JSON.stringify(newUsersTemp) !== JSON.stringify(this.newUsers)) {
                this.newUsers = newUsersTemp;
            }
            if (JSON.stringify(newTradesTemp) !== JSON.stringify(this.newTrades)) {
                this.newTrades = newTradesTemp;
            }
          }

          // Display or process the data as required. For now, we're just logging it.
          //console.log("New Users:", this.newUsers);
          //console.log("New Trades:", this.newTrades);
        })
        .catch(error => {
          console.log('There was a problem with the fetch operation:', error.message);
        });
    },
    connectWallet: function (provider) {
      web3Modal.connect().then((provider) => {
        // Get a Web3 instance for the wallet
        web3 = new Web3(provider);
        this.web3 = web3;

        web3.eth.getAccounts().then((wallet) => {
          console.log("Wallet = ", wallet[0]);
          this.address = wallet[0];
          //this.fetchBalance();

          web3.eth.getChainId().then((chain) => {
            this.chain = chain;
            console.log("Chain ID = ", chain);
          });
        });
      });
    },
  },
  mounted() {
    init();
    this.web3 = new Web3(new Web3.providers.HttpProvider("https://base.blockpi.network/v1/rpc/public")); // Use your Infura Project ID
    this.web3s = new Web3(new Web3.providers.WebsocketProvider("wss://base.gateway.tenderly.co")); // Use your Infura Project ID

    this.fetchActivity();
    setInterval(() => this.fetchActivity(), 5000); // Because our RPC does not support continuous events...
    setInterval(() => this.fetchPrice(), 10000);
    this.fetchBalance();
    setInterval(() => this.fetchBalance(), 60000);
    this.updateSnipes();

  //   this.moment.updateLocale('en', {
  //     relativeTime : {
  //         future: "in %s",
  //         past:   "%s ago",
  //         s  : '%d seconds',
  //         ss : '%d seconds',
  //         m:  "a minute",
  //         mm: "%d minutes",
  //         h:  "1 hour ago", //this is the setting that you need to change
  //         hh: "%d hours",
  //         d:  "a day",
  //         dd: "%d days",
  //         w:  "a week",
  //         ww: "%d weeks",
  //         M:  "1 month ago", //change this for month
  //         MM: "%d months",
  //         y:  "a year",
  //         yy: "%d years"
  //     }
  // });

  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  /* margin-top: 20px; */
}
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  /* flex-direction: column; */
}
.router-link-active {
  border-bottom: 1px solid #42b983;
}
footer {
  position: sticky;
  top: 99%;
  bottom: 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
